export default "__VITE_ASSET__DXpe77AM__"